import React, { Component } from 'react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import FlatButton from 'material-ui/FlatButton';
import CircularProgress from 'material-ui/CircularProgress';

class CreateExerciseForm extends Component {
  constructor(props) {
    super(props);

    const text = props.text ? (props.text.texts.map(singleText => singleText.source)).join(' ') : '';
    const saveToGroup = this.props.forceGroupSave || (this.props.exercise !== null && this.props.exercise.group_id !== null);

    this.state = {
      name: (props.exercise && props.exercise.name) || '',
      language: props.language || 'en-GB',
      mode: props.mode || 'normal',
      text,
      saveToGroup,
    };
  }

  handleSave = (e) => {
    e.preventDefault();
    const editMode = this.props.exercise !== null;

    if (editMode) {
      this.props.updateExercise(this.props.exercise.id,
          { name: this.state.name,
            language: this.state.language,
            text: this.state.text,
            saveToGroup: this.state.saveToGroup,
            mode: this.state.mode
          });
    } else {
      this.props.saveExercise(this.state.name, this.state.language, this.state.text, this.state.mode, this.state.saveToGroup);
    }
  }

  handleLanguageChange = (event, index, language) => { event.preventDefault(); this.setState({ language }); }

  handleName = (event) => { event.preventDefault(); this.setState({ name: event.target.value }); }

  handleText = (event) => { event.preventDefault(); this.setState({ text: event.target.value }); }
  handleMode = (event, index, mode) => { event.preventDefault(); this.setState({ mode }); }

  render() {
    const editMode = this.props.exercise !== null;
    const disabled = (this.state.name.length === 0 || this.state.text.length === 0) || this.props.isWaiting.EXERCISE_CREATE || this.props.isWaiting.EXERCISE_UPDATE;

    const stats = {
      length: this.state.text.length,
      words: this.state.text.length === 0 ? (this.state.text.split(' ').length - 1) : this.state.text.split(' ').length,
    };

    const labelText = editMode ? 'Update exercise' : 'Save new exercise';
    const createLabel = (this.props.isWaiting.EXERCISE_CREATE || this.props.isWaiting.EXERCISE_UPDATE) ? <CircularProgress size={20} /> : labelText;
    let type;

    if (editMode) {
      type = (this.props.exercise.group_id !== null) ? 'This is a group exercise.' : 'This is your personal exercise.';
    }

    const saveToGroup = this.props.canSaveToGroup &&
    <Checkbox
      disabled={this.props.forceGroupSave || (editMode && this.props.exercise.group_id !== null)}
      label="Save as a group exercise (visible to all in group)"
      checked={this.state.saveToGroup}
      onCheck={() => this.setState({ saveToGroup: !this.state.saveToGroup })}
    />;
    return (
      <form>
        <br />
        <p>{type}</p>
        {saveToGroup}
        <TextField onChange={this.handleName} errorText={this.props.nameErrorMessage} type="text" name="name" floatingLabelText="Exercise name" value={this.state.name} /><br />
        <SelectField
          floatingLabelText="Language"
          value={this.state.language}
          onChange={this.handleLanguageChange}
        >
          <MenuItem value="en-GB" primaryText="English (UK)" />
          <MenuItem value="en-US" primaryText="English (US)" />
          <MenuItem value="en-IN" primaryText="English (Indian)" />
          <MenuItem value="de-DE" primaryText="German" />
          <MenuItem value="es-ES" primaryText="Spanish" />
          <MenuItem value="es-US" primaryText="Spanish (US)" />
          <MenuItem value="fr-FR" primaryText="French" />
          <MenuItem value="hi-IN" primaryText="Hindi" />
          <MenuItem value="id-ID" primaryText="Indonesian" />
          <MenuItem value="it-IT" primaryText="Italian" />
          <MenuItem value="ja-JP" primaryText="Japanese" />
          <MenuItem value="ko-KR" primaryText="Korean" />
          <MenuItem value="nl-NL" primaryText="Dutch" />
          <MenuItem value="pl-PL" primaryText="Polish" />
          <MenuItem value="pt-BR" primaryText="Portuguese (Brazil)" />
          <MenuItem value="ru-RU" primaryText="Russian" />
          <MenuItem value="zh-CN" primaryText="Chinese" />
          <MenuItem value="zh-TW" primaryText="Chinese (Taiwan)" />
          <MenuItem value="zh-HK" primaryText="Chinese (Hong Kong)" />
        </SelectField>
        <br />
          <SelectField
            floatingLabelText="Mode"
            value={this.state.mode}
            onChange={this.handleMode}
          >
            <MenuItem value="normal" primaryText="Normal" />
            <MenuItem value="flipped" primaryText="Flipped" />
          </SelectField>
          <br />
        <textarea className="pronounce-exercise-text" value={this.state.text} onChange={this.handleText} /><br />
        <div>{stats.length} characters - {stats.words} words</div>
        {this.props.textErrorMessage}
        <FlatButton type="submit" disabled={disabled} onClick={this.handleSave} label={createLabel} />

      </form>
    );
  }
}

export default CreateExerciseForm;



// WEBPACK FOOTER //
// ./src/components/CreateExerciseForm.js